(() => {
  if (window.__variantUrlFix) return;
  window.__variantUrlFix = true;

  function findActiveVariantId() {
    // 1) tenta dentro do próprio variant-picker (quando o tema mantém o form ali)
    const picker = document.querySelector("variant-picker");
    const idInPicker =
      picker?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value ||
      picker?.closest('form[action*="/cart/add"]')?.querySelector('input[name="id"]')?.value;

    if (idInPicker) return idInPicker;

    // 2) pega o primeiro form de add-to-cart VISÍVEL
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
    for (const f of forms) {
      if (f.offsetParent === null) continue; // invisível
      const v = f.querySelector('input[name="id"]')?.value;
      if (v) return v;
    }

    // 3) fallback
    return document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value || null;
  }

  function setVariantOnUrl(id) {
    if (!id) return;
    const url = new URL(location.href);
    if (url.searchParams.get("variant") === String(id)) return;
    url.searchParams.set("variant", String(id));
    history.replaceState({}, "", url.toString());
  }

  // “ganha” de qualquer replaceState do tema: sempre carimba com o id atual
  const _replace = history.replaceState.bind(history);
  history.replaceState = (state, title, url) => {
    const id = findActiveVariantId();
    if (id) {
      const u = url ? new URL(String(url), location.origin) : new URL(location.href);
      u.searchParams.set("variant", String(id));
      return _replace(state, title, u.toString());
    }
    return _replace(state, title, url);
  };

  // Watcher: quando o variant final mudar, atualiza a URL
  let last = null;
  setInterval(() => {
    const id = findActiveVariantId();
    if (id && id !== last) {
      last = id;
      setVariantOnUrl(id);
    }
  }, 120);

  // ajuda no timing do clique
  function kickSync() {
    setTimeout(() => setVariantOnUrl(findActiveVariantId()), 0);
    setTimeout(() => setVariantOnUrl(findActiveVariantId()), 180);
    setTimeout(() => setVariantOnUrl(findActiveVariantId()), 380);
  }

  document.addEventListener(
    "click",
    (e) => {
      if (e.target?.closest?.("variant-picker")) kickSync();
    },
    true
  );
  document.addEventListener(
    "change",
    (e) => {
      if (e.target?.closest?.("variant-picker")) kickSync();
    },
    true
  );

  document.addEventListener("DOMContentLoaded", kickSync);
})();